export default "__VITE_PUBLIC_ASSET__e989debf__"